import { useRef } from 'react';

export default function useExclusiveVideoPlayback() {
  const videos = useRef(new Map());
  const register = (id, video) => {
    if (video) videos.current.set(id, video);
    else videos.current.delete(id);
  };
  const pauseOthers = activeId => {
    videos.current.forEach((video, id) => {
      if (id !== activeId) video.pause();
    });
  };
  return { register, pauseOthers };
}
